export enum HttpHeaderName {
  XDisplayCurrency = "X-Display-Currency",
}
